import * as React from 'react';
import { SUGGEST_PROP_DEFAULTS } from '../constants';
export function useMaxLinesCssVarable(params) {
  React.useEffect(function () {
    var _params$ref$current, _ref, _params$maxLines;
    (_params$ref$current = params.ref.current) === null || _params$ref$current === void 0 || _params$ref$current.style.setProperty('--suggest-max-lines', (_ref = (_params$maxLines = params.maxLines) !== null && _params$maxLines !== void 0 ? _params$maxLines : SUGGEST_PROP_DEFAULTS.maxLines) === null || _ref === void 0 ? void 0 : _ref.toString());
  }, [params.maxLines, params.ref, params.open]);
}